import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { googleOAuthCallback } from '@/api/auth';
import { getDefaultRedirect } from '@/hooks/useAuth';
import './oauth-callback.css';

export function OAuthCallbackPage() {
  const navigate = useNavigate();
  const called = useRef(false);

  useEffect(() => {
    // Strict-mode guard — run the exchange only once
    if (called.current) return;
    called.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code || !state) {
      navigate('/login?error=oauth_failed', { replace: true });
      return;
    }

    googleOAuthCallback(code, state)
      .then((response) => {
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('refresh_token', response.refresh_token);

        // Decode the JWT to determine the correct dashboard redirect
        try {
          const payload = JSON.parse(atob(response.access_token.split('.')[1]));
          const roles: string[] = payload.roles || [];
          window.location.href = getDefaultRedirect(roles);
        } catch {
          window.location.href = '/';
        }
      })
      .catch(() => {
        navigate('/login?error=oauth_failed', { replace: true });
      });
  }, [navigate]);

  return (
    <div className="oauth-callback">
      <div className="oauth-callback__spinner" />
      <p className="oauth-callback__text">Signing you in with Google...</p>
    </div>
  );
}
